import { render, staticRenderFns } from "./Representantes.vue?vue&type=template&id=6686f6b5&scoped=true&"
import script from "./Representantes.vue?vue&type=script&lang=js&"
export * from "./Representantes.vue?vue&type=script&lang=js&"
import style0 from "./Representantes.vue?vue&type=style&index=0&id=6686f6b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6686f6b5",
  null
  
)

export default component.exports